<template>
  <div>
    <van-swipe :autoplay="3000" :height="swipeHeight" class="banner">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img :src="image" />
      </van-swipe-item>
    </van-swipe>
    <div :class="{'body-box': true, 'body-box-light': defaultTheme == 'light' }" :style="`height: ${bodyHeight}px; top: ${swipeHeight}px`">
      <div class="notice-box pt20 pm15 ml10 mr10 bgbs">
        <div class="notice-tit row pm20 fz18">
          <div class="notice-tit-line"></div>
          <div>预约须知</div>
          <div class="notice-tit-line notice-tit-line-right"></div>
        </div>
        <div class="notice-body pl15 pr15 z3 fz12">
          <p>
            <span class="notice-tit cf fz16">开馆时间</span>
          </p>
          <p v-if="notice.timeNoticeForYeTing && exhibitionHall.toLowerCase()=='yeting'" class="pt10 pm10" v-html="notice.timeNoticeForYeTing"></p>
          <p v-if="notice.timeNoticeForSecretRescue && exhibitionHall.toLowerCase()=='secretrescue'" class="pt10 pm10" v-html="notice.timeNoticeForSecretRescue"></p>
          <p>
            <span class="notice-tit cf fz16">预约须知</span>
          </p>
          <p v-if="notice.orderNoticeForYeTing && exhibitionHall.toLowerCase()=='yeting'" class="pt10" v-html="notice.orderNoticeForYeTing"></p>
          <p v-if="notice.orderNoticeForSecretRescue && exhibitionHall.toLowerCase()=='secretrescue'" class="pt10" v-html="notice.orderNoticeForSecretRescue"></p>
        </div>
      </div>
      <div class="btn-box pl10 pr10">
        <div class="pd pt10 pm10 fz14" >
          <van-checkbox v-if="showCountdown" v-model="isAgree" icon-size="16px" checked-color="#a86061" :disabled="agreeDisabled">
            我已认真阅读预约须知并同意
            <span v-if="countdownCount > 0">({{countdownCount}}S)</span>
          </van-checkbox>
        </div>
        <van-row gutter="8" :class="{'dsfstywer': true, 'sdrtter': showCountdown && (!isAgree || countdownCount > 0)}">
          <van-col :span="groupBookEnable ? 12 : 24" class="btn-item row">
            <!-- <van-button type="primary" color="#a9716d"><div style="display: flex; align-items: flex-end; align-items: center;" @click="toCreateOrder" ><van-icon name="manager" size="32" color="#ffffff" /> <span style="line-height: 13px;margin-left: 5px">散客<br><span style="font-size:10px;">(个人及家庭)</span></span> </div></van-button> -->
            <img src="../../assets/img/btn_person.png" class="book-btn" @click="toCreateOrder" />
          </van-col>
          <van-col v-if="groupBookEnable" span="12" class="btn-item row">
            <!-- <van-button type="primary" color="#a9716d"><div style="display: flex; align-items: flex-end; align-items: center;"  @click="toCreateGroupOrder"><van-icon name="friends" size="35" color="#ffffff"/> <span  style="line-height: 13px;margin-left: 5px">团队<br><span style="font-size:10px;">(单位及社团)</span></span> </div></van-button> -->
            <img src="../../assets/img/brn_team.png" class="book-btn" @click="toCreateGroupOrder"/>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import scenicImage1 from "@/assets/img/banner.jpg";
import { mapState, mapActions } from "vuex";
import appConsts from "@/store/consts.js";

export default {
  name: "home",
  props: {
    exhibitionHall: {
      type: String
    }
  },
  data() {
    return {
      defaultTheme: window.defaultTheme,
      images: [scenicImage1],
      swipeHeight: 160,
      bodyHeight: 450,
      isAgree: false,
      agreeDisabled: true,
      showCountdown: true,
      countdownCount: 5,
      groupBookEnable: window.groupBookEnable,
      addChildren: window.addChildren
    };
  },
  async created() {
    await this.getOrderNotice();
  },
  computed: {
    ...mapState({
      notice: (state) => state.homeModule.notice
    }),
  },
  methods: {
    async getOrderNotice() {
      await this.loadOrderNoticeAsync();
      if(this.exhibitionHall.toLowerCase()=='yeting')
        this.countdownCount = Number(this.notice.countdownCountForYeTing);
      else if(this.exhibitionHall.toLowerCase()=='secretrescue')
        this.countdownCount = Number(this.notice.countdownCountForSecretRescue);
      if (this.countdownCount > 0) {
        this.showCountdown = true;
        let sdd = setInterval(() => {
          if (this.countdownCount-- <= 1) {
            clearTimeout(sdd);
            this.agreeDisabled = false;
          }
        }, 1000);
      } else {
        this.showCountdown = false;
      }
    },
    toCreateOrder() {
      if(this.exhibitionHall.toLowerCase()=="yeting"){
        this.$router.push({
          name: "createorder",
          params: { addChildren: this.addChildren?"true":"false", ticketTypeIds: this.notice.ticketTypeIdsForYeTing },
        });
      }
      else if(this.exhibitionHall.toLowerCase()=="secretrescue"){
        this.$router.push({
          name: "createorder",
          params: { addChildren: this.addChildren?"true":"false", ticketTypeIds: this.notice.ticketTypeIdsForSecretRescue },
        });
      }
      
    },
    toCreateGroupOrder() {
      if (!this.groupBookEnable) {
        this.$toast("暂未开放，敬请期待！");
        return;
      }

      
      if(this.exhibitionHall.toLowerCase()=="yeting"){
        this.$router.push({
          name: "creategrouporderbyadmin",
          params: { ticketTypeIds: this.notice.ticketTypeIdsForYeTing },
        });
      }
      else if(this.exhibitionHall.toLowerCase()=="secretrescue"){
        this.$router.push({
          name: "creategrouporderbyadmin",
          params: { ticketTypeIds: this.notice.ticketTypeIdsForSecretRescue },
        });
      }
    },
    resize() {
      const clientW = document.documentElement.clientWidth;
      const widthRatio = clientW / 750;
      this.swipeHeight = widthRatio * 320;
      this.bodyHeight = document.documentElement.clientHeight - this.swipeHeight - 40;
    },
    ...mapActions("homeModule", [appConsts.loadOrderNoticeAsync])
  },
  mounted() {
    this.resize();
    let vm = this;
    window.onresize = function () {
      vm.resize();
    };
  }
};
</script>

<style lang="scss" scoped>
.banner {
  img {
    width: 100%;
    height: 100%;
  }
  /deep/ .van-swipe__indicators {
    bottom: 32px;
  }
}
.body-box {
  width: 100%;
  position: absolute;
  background: url("../../assets/img/indexbg.jpg") no-repeat #f2e9d7;
  background-size: cover;
  .notice-box {
    margin-top: -20px;
    border-radius: 6px;
    flex: 1;
    height: calc(100% - 95px);
    .notice-tit {
      justify-items: center;
      justify-content: center;
      .notice-tit-line {
        margin: 13px 15px 12px;
        width: 40px;
        height: 1px;
        background: linear-gradient(to right, #fff, #6a4240);
      }
      .notice-tit-line-right {
        background: linear-gradient(to right, #6a4240, #fff);
      }
    }
    .notice-body {
      height: calc(100% - 45px);
      line-height: 28px;
      overflow-y: scroll;
      .notice-tit {
        background: #a9716d;
        display: inline-block;
        width: 91px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-top-right-radius: 10px;
      }
    }
  }
  .btn-box {
    .btn-item {
      justify-content: center;
      .book-btn {
        width: 135px;
        height: 50px;
      }
    }
  }
}
</style>
